<main>
  <loading-overlay [isLoading]="isLoading() > 0" />

  <header>
    <div class="headline">
      <h1>
        {{ 'RollQcDetail_Title' | translateWF: 'Roll Quality Control' }}
      </h1>
      <csl-dropdown [formControl]="status" [enumObject]="statusEnumObject" [enumValueOptions]="statusesForSelect" />
    </div>
  </header>

  <div class="content">
    <app-qr-scanner-modal *ngIf="canEdit()" (isScannedCode)="onQrCodeScanned($event)" />

    <p-card>
      <div class="grid-12">
        <div class="span-6">
          <form>
            <div class="col-sm mt-3">
              <label for="">
                {{ 'RollQcDetail_ID' | translateWF: 'Roll ID' }}
              </label>
              <p-autoComplete
                [dropdownIcon]="'pi pi-search'"
                [formControl]="selectedRoll"
                [dropdown]="true"
                #rollSearchRef="cslServerSearch"
                [cslServerSearch]="fetchRolls"
                [suggestions]="rollSearchRef.results()"
                optionLabel="number"
                styleClass="w-full"
                [minlength]="1"
                [delay]="200"
              />
            </div>

            <div class="col-sm mt-3">
              <label for="">
                {{ 'RollQcDetail_InitialWeight' | translateWF: 'Initial Weight' }}
              </label>
              <input type="text" pInputText [formControl]="initialWeight" />
            </div>

            <div class="col-sm mt-3">
              <label for="">
                {{ 'RollQcDetail_KnittingMachine' | translateWF: 'Knitting Machine' }}
              </label>
              <input type="text" pInputText [formControl]="knittingMachine" />
            </div>

            <div class="col-sm mt-3">
              <label for="">
                {{ 'RollQcDetail_FullNameOperator' | translateWF: 'Full Name Operator' }}
              </label>
              <input type="text" pInputText [formControl]="operatorFullName" />
            </div>

            <div class="col-sm mt-3">
              <label for=""> {{ 'RollQcDetail_QCMachine' | translateWF: 'QC Machine' }} <span class="text-red-500">*</span> </label>
              <p-select
                styleClass="w-full"
                [formControl]="stationAssetId"
                [options]="qcMachines()"
                optionLabel="assetId"
                optionValue="assetId"
                [showClear]="true"
                placeholder="{{ 'RollQcDetail_SelectQCMachine' | translateWF: 'Select QC Machine' }}"
              />
            </div>

            <div class="col-sm mt-3">
              <label for="">
                {{ 'RollQcDetail_QualityDefect' | translateWF: 'Quality Defect' }}
              </label>

              <p-select
                styleClass="w-full"
                [formControl]="qualityDefectReference"
                [options]="qualityDefectsTranslated()"
                optionLabel="name"
                optionValue="id"
                [showClear]="true"
                (onChange)="onQualityDefectChange($event)"
              />
            </div>

            <ul class="col-sm mt-3">
              @for (group of groupedComments.controls; track $index) {
                <li class="flex w-full p-3 rounded-lg shadow-md bg-white" [formGroup]="group" [ngClass]="{ 'bg-red-50': group.invalid }">
                  <div class="w-full row-between-center">
                    <p>
                      {{ group.get('name')?.value }}
                    </p>
                    <div class="row-sm border p-1 rounded-lg bg-gray-100">
                      <p-button icon="pi pi-minus" severity="secondary" [disabled]="isRollProcessed()" (onClick)="decreaseValue($index)" />
                      <input type="number" class="border rounded text-center w-10" [readOnly]="true" value="1" formControlName="quantity" />
                      <p-button icon="pi pi-plus" severity="secondary" [disabled]="isRollProcessed()" (onClick)="increaseValue($index)" />
                    </div>
                    <input type="text" pInputText placeholder="Description" formControlName="comment" />
                    <p-button
                      icon="pi pi-trash"
                      severity="secondary"
                      class="p-button-sm"
                      variant="text"
                      [disabled]="isRollProcessed()"
                      (click)="deleteGroupedRollQualityDefect($index)"
                    />
                  </div>
                </li>
              }
            </ul>

            <div class="col-sm mt-3" [ngClass]="{ 'opacity-50': !currentRoll() || isRollProcessed() }">
              <h4 [ngClass]="{ 'text-gray-400': !currentRoll() || isRollProcessed() }">
                {{ 'RollQcDetail_Attachments' | translateWF: 'Attachments' }}
              </h4>
              <input type="file" class="hidden" #fileInput (change)="uploadFile($event, fileInput)" />
              <button
                class="border-2 border-dashed p-3 rounded-lg font-semibold transition-all duration-200"
                [ngClass]="{
                  'border-gray-300 text-gray-400 cursor-not-allowed bg-gray-100': !currentRoll() || isRollProcessed(),
                  'border-gray-400 text-gray-700 hover:border-teal-500 hover:bg-teal-50': currentRoll() && !isRollProcessed(),
                }"
                (click)="currentRoll() && !isRollProcessed() ? fileInput.click() : null"
                [disabled]="!currentRoll() || isRollProcessed()"
              >
                {{ 'RollQcDetail_DocumentsSupport' | translateWF: 'Documents Support' }}
                <span [ngClass]="{ 'text-teal-500': currentRoll() && !isRollProcessed(), 'text-gray-400': !currentRoll() || isRollProcessed() }">{{
                  'RollQcDetail_Browser' | translateWF: 'Browser'
                }}</span>
              </button>
              <ul class="w-full grid-2 grid-flow-row-sm mt-3">
                @for (file of files(); track $index) {
                  <li class="w-full row-between-center ps-2 py-1 rounded-lg bg-gray-300">
                    <p class="font-medium">{{ 'Roll_QC_Details_File_Name' | translateWF: 'File Name' }}</p>
                    <p-button icon="pi pi-times" severity="secondary" class="p-button-sm" variant="text" />
                  </li>
                } @empty {
                  <p-tag severity="info">{{ 'Roll_QC_Details_No_Files_Attached' | translateWF: 'No files attached' }}</p-tag>
                }
              </ul>
            </div>

            <div class="col-sm mt-3">
              <label for="">{{ 'RollQcDetail_Comments' | translateWF: 'Comments' }}</label>
              <textarea pTextarea [rows]="5" [formControl]="comments"></textarea>
            </div>
          </form>
        </div>

        <div *ngIf="canEdit() && !isLocationRestricted()" class="span-6 col">
          @if (status.value !== RollStatus.PartiallyApproved) {
            <app-weight-control
              title="Stand Weight (Lbs)"
              tagText="Weight"
              tagClass="bg-blue-400 text-blue-800"
              [scaleData]="scaleData"
              [initialWeight]="initialWeight.value || 0"
              [minWeight]="initialWeight.value || 0"
              [savedWeight]="standWeight()"
              [disabled]="hasBeenScanned()"
              [rollNumber]="selectedRoll.value?.number"
              (weightSaved)="onStandWeightSaved($event)"
              (weightReset)="onStandWeightReset()"
              (printRequested)="printRoll($event)"
            />
            @if (qcmWeight(); as qcm) {
              <div class="row-sm-start-center">
                <span class="font-medium">{{ 'RollQcDetail_QcmWeight' | translateWF: 'QCM Weight (Lbs)' }}:</span>
                <p-tag severity="info" [value]="(qcm.weightInLbs | number: '1.2-2') + ' (' + qcm.stationAssetId + ')'" />
              </div>
            }
          }

          @if (status.value === RollStatus.PartiallyApproved) {
            <app-weight-control
              title="Approved Weight (Lbs)"
              tagText="Approved"
              tagClass="bg-green-400 text-green-800"
              [scaleData]="scaleData"
              [initialWeight]="initialWeight.value || 0"
              [savedWeight]="approvedWeight()"
              [disabled]="hasBeenScanned()"
              [rollNumber]="getApprovedRollNumber()"
              (weightSaved)="onApprovedWeightSaved($event)"
              (weightReset)="onApprovedWeightReset()"
              (printRequested)="printRoll($event)"
            />

            <app-weight-control
              title="Rejected Weight (Lbs)"
              tagText="Rejected"
              tagClass="bg-red-400 text-red-800"
              [scaleData]="scaleData"
              [initialWeight]="initialWeight.value || 0"
              [savedWeight]="rejectedWeight()"
              [disabled]="hasBeenScanned()"
              [rollNumber]="getRejectedRollNumber()"
              (weightSaved)="onRejectedWeightSaved($event)"
              (weightReset)="onRejectedWeightReset()"
              (printRequested)="printRoll($event)"
            />
          }
        </div>
      </div>
    </p-card>

    @if (lastRecordsOfQC()) {
      <p-panel [header]="'RollQcDetail_RecentDefects' | translateWF: 'Recent Defects'">
        <ng-template pTemplate="icons">
          <p-selectButton [formControl]="defectsView" [options]="defectsViewOptions" (onChange)="onDefectsViewChange()" optionLabel="label" optionValue="value" class="inline-flex">
            <ng-template let-option pTemplate="item">
              @if (option.value === 'machine') {
                <i class="pi pi-cog"></i>
              } @else {
                <i class="pi pi-user"></i>
              }
            </ng-template>
          </p-selectButton>
        </ng-template>
        <div class="col-sm">
          <p-message severity="info">
            <i class="pi pi-exclamation-triangle text-orange-300"></i>
            {{ 'RollQcDetail_LastRecords' | translateWF: 'Records for the last 48 hours' }}
          </p-message>

          @if (defectsView.value === 'machine') {
            <p-panel data-tone="surface" [header]="'RollQcDetail_MachineDefectsSummary' | translateWF: 'Machine Defects Summary'">
              <p-card data-variant="compact">
                <p-table [value]="getGroupedDefects()" class="table__sm">
                  <ng-template #header>
                    <tr>
                      <th>{{ 'RollQcDetail_MachineID' | translateWF: 'Machine ID' }}</th>
                      <th>{{ 'RollQcDetail_RollNumbers' | translateWF: 'Roll Numbers' }}</th>
                      <th>{{ 'RollQcDetail_DefectCount' | translateWF: 'Total Defects' }}</th>
                      <th>{{ 'RollQcDetail_LatestDefect' | translateWF: 'Latest Defect' }}</th>
                      <th>{{ 'RollQcDetail_LatestComments' | translateWF: 'Latest Comments' }}</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-machine>
                    <tr>
                      <td>{{ machine.assetId }}</td>
                      <td>{{ machine.rollNumbers }}</td>
                      <td>{{ machine.defectCount }}</td>
                      <td>{{ getQualityDefectByReference(machine.latestDefect?.qualityDefectReference) }}</td>
                      <td>{{ machine.latestDefect?.comments }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-card>
            </p-panel>
          } @else {
            <p-panel data-tone="surface" [header]="'RollQcDetail_OperatorDefectsSummary' | translateWF: 'Operator Defects Summary'">
              <p-card data-variant="compact">
                <p-table [value]="getGroupedDefects()" class="table__sm">
                  <ng-template #header>
                    <tr>
                      <th>{{ 'RollQcDetail_OperatorName' | translateWF: 'Operator Name' }}</th>
                      <th>{{ 'RollQcDetail_RollNumbers' | translateWF: 'Roll Numbers' }}</th>
                      <th>{{ 'RollQcDetail_DefectCount' | translateWF: 'Total Defects' }}</th>
                      <th>{{ 'RollQcDetail_LatestDefect' | translateWF: 'Latest Defect' }}</th>
                      <th>{{ 'RollQcDetail_LatestComments' | translateWF: 'Latest Comments' }}</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-operator>
                    <tr>
                      <td>{{ operator.createdBy }}</td>
                      <td>{{ operator.rollNumbers }}</td>
                      <td>{{ operator.defectCount }}</td>
                      <td>{{ getQualityDefectByReference(operator.latestDefect?.qualityDefectReference) }}</td>
                      <td>{{ operator.latestDefect?.comments }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-card>
            </p-panel>
          }
        </div>
      </p-panel>
    }
    @for (item of uniqueScanned; track $index) {
      <p-tag>{{ item }}</p-tag>
    }
  </div>

  <footer class="main__actions">
    <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" (click)="onCancel()" variant="outlined" />
    <p-button
      *ngIf="canEdit()"
      [label]="'Common_Save' | translateWF: 'Save'"
      (click)="onSave()"
      [disabled]="!canSaveQualityControl() || (isRollProcessed() && currentRoll()?.status !== RollStatus.PartiallyApproved)"
    />
  </footer>
</main>
